import clsx from "clsx";
import { FC } from "react";

import { LiveMapRideFilterEnum } from "@ryde/shared";

import { LiveMapRideFilterIcon } from "./live-map-ride-filter.icon";

interface ILiveMapRideFilterPreview {
  filter: LiveMapRideFilterEnum;
}

export const LiveMapRideFilterPreview: FC<ILiveMapRideFilterPreview> = ({
  filter,
}) => (
  <div className="live-map-ride-filter-preview" aria-hidden>
    <LiveMapRideFilterIcon
      filter={filter}
      className={clsx(
        "live-map-ride-filter-preview__image",
        filter === LiveMapRideFilterEnum.all &&
          "live-map-ride-filter-icon--muted",
        filter !== LiveMapRideFilterEnum.all &&
          "live-map-ride-filter-icon--active",
      )}
    />
  </div>
);
